import { getTodaysDate } from '../util/commonUtil';
import client from './TokenInterceptorServices';

let todaysDate = getTodaysDate();

export const getGcspMyDashboardData = async (YEAR, ACCOUNT_ID, EMAIL, DATE) => {
  // Email Required *
  try {
    const URL = `/opportunity/gcspPerformanceMetrics?year=${YEAR}&account_id=${ACCOUNT_ID}&email=${EMAIL}&date=${DATE}`;
    const response = await client.get(URL);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getGcspAllQuarterData = async (EMAIL, ACCOUNT_ID, YEAR) => {
  try {
    const URL = `opportunity/gcspYearlyOpportunity2?email=${EMAIL}&account_id=${ACCOUNT_ID}&year=${YEAR}&date=${todaysDate}`;
    const response = await client.get(URL);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getGcspMyDashboardQuarterData = async (
  QUARTER,
  YEAR,
  SERVICE_LINE,
  EMAIL,
  ACCOUNT_ID,
) => {
  try {
    const URL = `opportunity/gcspQuarterlyOpportunity2?email=${EMAIL}&quarter=${QUARTER.toLowerCase()}&service=${SERVICE_LINE.toLowerCase()}&year=${YEAR}&calculation=true&account_id=${ACCOUNT_ID}&date=${todaysDate}`;
    const response = await client.get(URL);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getGcspYearlyMetrics = async (YEAR, SERVICE_LINE, ACCOUNT_ID, EMAIL, DATE) => {
  // Email Required *
  const URL = `/opportunity/gcsp/yearlymetrics?year=${YEAR}&service=${SERVICE_LINE.toLowerCase()}&account_id=${ACCOUNT_ID}&email=${EMAIL}&date=${DATE}`;
  try {
    const response = await client.get(URL);
    return response.data[0];
  } catch (error) {
    throw error;
  }
};

export const getGCSPOpportunities = async (
  // Email Required *
  GCSP_ID,
  ACCOUNT_ID,
  MONTH,
  YEAR,
  TYPE,
  START_DATE,
  END_DATE,
  EMAIL,
) => {
  try {
    let URL = `/opportunity/gcsp/opportunityview?gcspid=${GCSP_ID}&accountid=${ACCOUNT_ID}&start_date=${START_DATE}&end_date=${END_DATE}&type=${TYPE}&year=${YEAR}&month=${MONTH}&email=${EMAIL}`;
    const response = await client.get(URL);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getGCSProllingOpportunities = async (
  GCSP_ID,
  ACCOUNT_ID,
  MONTH,
  YEAR,
  TYPE,
  START_DATE,
  END_DATE,
  CURRENT_MONTH,
  EMAIL,
) => {
  try {
    let URL = `/opportunity/gcsp/rollingopportunityview?gcspid=${GCSP_ID}&accountid=${ACCOUNT_ID}&start_date=${START_DATE}&end_date=${END_DATE}&type=${TYPE}&month=${MONTH}&year=${YEAR}&email=${EMAIL}&submitted_month=${CURRENT_MONTH}`;
    const response = await client.get(URL);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getGcspAccountList = async EMAIL => {
  try {
    let URL = `/opportunity/identifypersona?email=${EMAIL}`;
    const response = await client.get(URL);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getGcspOpportunitiesDue = async (EMAIL, systemDateTime) => {
  // Email Required *
  const todaysDate = getTodaysDate();
  const URL = `/opportunity/date/${systemDateTime}?role=GCSP&email=${EMAIL}`;

  try {
    const response = await client.get(URL);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const postGCSPJudgeData = async (ACCOUNTID, EMAIL, MONTH, YEAR, QUARTER, REQ_BODY) => {
  try {
    const URL = `/opportunity/gcsp/judgeData?accountid=${ACCOUNTID}&year=${YEAR}&month=${MONTH}&quarter=${QUARTER}&email=${EMAIL}`;
    const response = await client.post(URL);
    return { status: response.status, msg: response.data.status, data: response.data };
  } catch (error) {
    console.log('Error while submitting : ', error);
    throw error;
  }
};

export const getGCSPForecastSubmitStatus = async (MONTH, YEAR, EMAIL, LIST_OF_ACCOUNTS) => {
  try {
    let URL = `/opportunity/gcsp/forecastsubmitstatus?email=${EMAIL}&role=GCSP&month=${MONTH}&year=${YEAR}&account_id=${LIST_OF_ACCOUNTS}`;
    const response = await client.get(URL);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const subHeaderGCSPPastQtrDetails = async (QUARTER, YEAR, EMAIL) => {
  // Email Required *
  try {
    let URL = `/opportunity/quarter/${QUARTER}?year=${YEAR}&email=${EMAIL}`;
    const response = await client.get(URL);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const subHeaderGCSPPastMonthDetails = async (QUARTER, MONTH, YEAR, EMAIL) => {
  // Email Required *
  try {
    let URL = `/opportunity/quarter/${QUARTER}?year=${YEAR}&month=${MONTH}&email=${EMAIL}`;
    const response = await client.get(URL);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getGCSPPastOpportunitiesMonthly = async (
  EMAIL,
  ACCOUNT_ID,
  MONTH,
  YEAR,
  TYPE,
  QUARTER,
) => {
  try {
    let URL = `/opportunity/gcsp/gcsppastopportunity?email=${EMAIL}&accountid=${ACCOUNT_ID}&type=${TYPE}&year=${YEAR}&month=${MONTH}&quarter=${QUARTER}
    `;
    const response = await client.get(URL);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getGCSPPastOpportunitiesQuaterly = async (
  EMAIL,
  ACCOUNT_ID,
  MONTH,
  YEAR,
  TYPE,
  QUARTER,
) => {
  try {
    let URL = `/opportunity/gcsp/gcsppastopportunity?email=${EMAIL}&accountid=${ACCOUNT_ID}&type=${TYPE}&year=${YEAR}&month=null&quarter=${QUARTER}
    `;
    const response = await client.get(URL);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const submitGCSPopportunity = async (
  ACCOUNT_ID,
  EMAIL,
  MONTH,
  YEAR,
  QUARTER,
  REQ_BODY_1,
  REQ_BODY_2,
) => {
  try {
    const promises = [
      client.post(
        `opportunity/gcsp/judgeData?accountid=${ACCOUNT_ID}&month=${MONTH}&year=${YEAR}&quarter=${QUARTER}&email=${EMAIL}`,
        REQ_BODY_1,
      ),
      client.post(
        `/opportunity/gcsp/rollingGcspJudgeData?accountid=${ACCOUNT_ID}&month=${MONTH}&year=${YEAR}&quarter=${QUARTER}&email=${EMAIL}`,
        REQ_BODY_2,
      ),
      client.get(
        `/opportunity/gcsp/updategcspforecastdata?accountid=${ACCOUNT_ID}&month=${MONTH}&year=${YEAR}&quarter=${QUARTER}&email=${EMAIL}&type=month`,
      ),
    ];
    const results = await Promise.all(promises.map(promise => promise.catch(error => ({ error }))));
    if (
      results.length !== 0 &&
      results[0].status === 200 &&
      results[1].status === 200 &&
      results[2].status === 200
    ) {
      return true;
    } else {
      return false;
      console.error('Error:', results);
    }
  } catch (error) {
    console.error('Error:', error);
  }
};

export const submitGgcspAggregateJudgeData = async (
  ACCOUNT_ID,
  EMAIL,
  MONTH,
  YEAR,
  QUARTER,
  REQ_BODY,
) => {
  try {
    const URL = `/opportunity/gcsp/judgeData?accountid=${ACCOUNT_ID}&year=${YEAR}&month=${MONTH}&quarter=${QUARTER}&email=${EMAIL}`;
    const response = await client.post(URL, REQ_BODY);

    return response.status == 200 ? true : false;
  } catch (error) {
    console.log('Error while submitting : ', error);
    throw error;
  }
};
